var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-create-wrap"
  }, [_c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "item title",
    class: {
      'title-focus': _vm.focusIndex === 'title'
    },
    on: {
      "click": function($event) {
        _vm.focusTitle($event)
      }
    }
  }, [_c('div', {
    staticClass: "li"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.display_name),
      expression: "data.display_name"
    }],
    staticClass: "form-title",
    attrs: {
      "placeholder": "表单标题"
    },
    domProps: {
      "value": (_vm.data.display_name)
    },
    on: {
      "focus": function($event) {
        _vm.$autoText($event)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.data.display_name = $event.target.value
      }, function($event) {
        _vm.$autoText($event)
      }]
    }
  })]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "card",
      "editable": ""
    },
    on: {
      "edit": _vm.handleTabsEdit
    },
    model: {
      value: (_vm.tabLang),
      callback: function($$v) {
        _vm.tabLang = $$v
      },
      expression: "tabLang"
    }
  }, _vm._l((_vm.editableTabs), function(item) {
    return _c('el-tab-pane', {
      key: item,
      attrs: {
        "label": item,
        "name": item
      }
    })
  })), _vm._v(" "), _vm._l((_vm.data.name), function(i) {
    return (i.language === _vm.langCode[_vm.langList.indexOf(_vm.tabLang)]) ? _c('div', {
      staticClass: "li"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (i.questionnaire_name),
        expression: "i.questionnaire_name"
      }],
      staticClass: "title-area",
      attrs: {
        "placeholder": "问卷标题"
      },
      domProps: {
        "value": (i.questionnaire_name)
      },
      on: {
        "focus": function($event) {
          _vm.$autoText($event)
        },
        "input": [function($event) {
          if ($event.target.composing) { return; }
          i.questionnaire_name = $event.target.value
        }, function($event) {
          _vm.$autoText($event)
        }]
      }
    })]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.data.name), function(i) {
    return (i.language === _vm.langCode[_vm.langList.indexOf(_vm.tabLang)]) ? _c('div', {
      staticClass: "li"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (i.desc),
        expression: "i.desc"
      }],
      attrs: {
        "placeholder": "问卷说明"
      },
      domProps: {
        "value": (i.desc)
      },
      on: {
        "focus": function($event) {
          _vm.$autoText($event)
        },
        "input": [function($event) {
          if ($event.target.composing) { return; }
          i.desc = $event.target.value
        }, function($event) {
          _vm.$autoText($event)
        }]
      }
    })]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "li-right"
  }, [_c('span', [_vm._v("允许重复提交")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "width": 40,
      "on-color": "#4ca2ae",
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.data.repeat_submit),
      callback: function($$v) {
        _vm.data.repeat_submit = $$v
      },
      expression: "data.repeat_submit"
    }
  })], 1), _vm._v(" "), (!_vm.data.question.length) ? _c('div', {
    staticClass: "add-list",
    on: {
      "click": _vm.addListFn
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "q-wrap"
  }, _vm._l((_vm.data.question), function(data, index) {
    return _c('draggable', {
      key: index,
      attrs: {
        "options": {
          group: 'people'
        },
        "move": _vm.onMove
      },
      on: {
        "start": function($event) {
          _vm.drag = true
        },
        "end": _vm.onEnd
      },
      model: {
        value: (data.question),
        callback: function($$v) {
          data.question = $$v
        },
        expression: "data.question"
      }
    }, [_c('div', {
      staticClass: "q-li",
      class: {
        'q-li-focus': _vm.focusIndex === index
      },
      attrs: {
        "id": "items"
      },
      on: {
        "click": function($event) {
          _vm.focusItem($event, index)
        }
      }
    }, [_c('div', {
      staticClass: "drap-area"
    }, [_c('i', {
      staticClass: "iconfont icon-tuozhuai"
    })]), _vm._v(" "), _vm._l((data.content), function(content, index1) {
      return (content.language === _vm.langCode[_vm.langList.indexOf(_vm.tabLang)]) ? _c('div', {
        staticClass: "q-item-wrap"
      }, [_c('div', {
        staticClass: "q-item q-title-wrap"
      }, [_c('div', {
        staticClass: "q-title"
      }, [_c('div', {
        staticClass: "li"
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (content.title),
          expression: "content.title"
        }],
        staticClass: "q-area",
        attrs: {
          "placeholder": "问题"
        },
        domProps: {
          "value": (content.title)
        },
        on: {
          "focus": function($event) {
            _vm.$autoText($event)
          },
          "input": [function($event) {
            if ($event.target.composing) { return; }
            content.title = $event.target.value
          }, function($event) {
            _vm.$autoText($event)
          }]
        }
      })])]), _vm._v(" "), (_vm.focusIndex === index) ? _c('el-select', {
        staticClass: "q-select",
        attrs: {
          "filterable": "",
          "placeholder": "请选择"
        },
        model: {
          value: (data.types),
          callback: function($$v) {
            data.types = $$v
          },
          expression: "data.types"
        }
      }, _vm._l((_vm.selectOptions), function(item) {
        return _c('el-option', {
          key: item,
          attrs: {
            "label": item,
            "value": item
          }
        })
      })) : _vm._e()], 1), _vm._v(" "), (data.types === '下拉列表' || data.types === '单选题' || data.types === '多选题' || data.types === '优先级') ? _c('div', {
        staticClass: "q-item"
      }, [_vm._l((content.answer), function(item, i) {
        return _c('div', {
          staticClass: "q-radio"
        }, [(data.types === '下拉列表' || data.types === '优先级') ? _c('div', {
          staticClass: "icon-radio"
        }, [_vm._v(_vm._s(i + 1) + ".")]) : _c('div', {
          staticClass: "icon-radio",
          class: {
            'icon-cirle': data.types === '单选题', 'icon-square': data.types === '多选题'
          }
        }), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (item.description),
            expression: "item.description"
          }],
          staticClass: "radio-input",
          domProps: {
            "value": (item.description)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              item.description = $event.target.value
            }
          }
        }), _vm._v(" "), (_vm.focusIndex === index) ? _c('i', {
          staticClass: "el-icon-close",
          on: {
            "click": function($event) {
              _vm.deleteRadioFn(index, index1, i)
            }
          }
        }) : _vm._e()])
      }), _vm._v(" "), (_vm.focusIndex === index) ? _c('div', {
        staticClass: "q-radio"
      }, [(data.types === '下拉列表' || data.types === '优先级') ? _c('div', {
        staticClass: "icon-radio"
      }, [_vm._v(_vm._s(content.answer.length + 1) + ".")]) : _c('div', {
        staticClass: "icon-radio",
        class: {
          'icon-cirle': data.types === '单选题', 'icon-square': data.types === '多选题'
        }
      }), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.addRadio),
          expression: "addRadio"
        }],
        staticClass: "radio-add",
        domProps: {
          "value": (_vm.addRadio)
        },
        on: {
          "focus": function($event) {
            _vm.addRadioFn(index, index1)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.addRadio = $event.target.value
          }
        }
      })]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (data.types === '线性量表') ? _c('div', {
        staticClass: "q-item line-wrap"
      }, [_c('div', {
        staticClass: "q-item-line"
      }, [_c('el-select', {
        model: {
          value: (content.line_answer.line_value),
          callback: function($$v) {
            content.line_answer.line_value = $$v
          },
          expression: "content.line_answer.line_value"
        }
      }, _vm._l((_vm.lineOptions), function(i) {
        return _c('el-option', {
          key: i,
          attrs: {
            "value": i
          }
        })
      })), _vm._v(" "), _c('span', {
        staticClass: "line-tip"
      }, [_vm._v("到")]), _vm._v(" "), _c('el-select', {
        model: {
          value: (content.line_answer.line_end_value),
          callback: function($$v) {
            content.line_answer.line_end_value = $$v
          },
          expression: "content.line_answer.line_end_value"
        }
      }, _vm._l((_vm.lineEndOptions), function(i) {
        return _c('el-option', {
          key: i,
          attrs: {
            "value": i
          }
        })
      }))], 1), _vm._v(" "), _c('div', {
        staticClass: "q-radio"
      }, [_c('div', {
        staticClass: "icon-radio"
      }, [_vm._v("1.")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (content.line_answer.line_tag),
          expression: "content.line_answer.line_tag"
        }],
        staticClass: "radio-input",
        attrs: {
          "placeholder": "标签（选填）"
        },
        domProps: {
          "value": (content.line_answer.line_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            content.line_answer.line_tag = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "q-radio"
      }, [_c('div', {
        staticClass: "icon-radio"
      }, [_vm._v("2.")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (content.line_answer.line_end_tag),
          expression: "content.line_answer.line_end_tag"
        }],
        staticClass: "radio-input",
        attrs: {
          "placeholder": "标签（选填）"
        },
        domProps: {
          "value": (content.line_answer.line_end_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            content.line_answer.line_end_tag = $event.target.value
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (data.types === '文本题') ? _c('div', {
        staticClass: "q-item text-wrap"
      }, [_vm._v("文本回答")]) : _vm._e(), _vm._v(" "), (data.types === '矩阵量表') ? _c('div', {
        staticClass: "q-item line-wrap square-wrap"
      }, [_c('div', {
        staticClass: "square-li"
      }, [_c('h4', [_vm._v("行")]), _vm._v(" "), _c('div', {
        staticClass: "q-item-line"
      }, [_c('el-select', {
        model: {
          value: (content.line_answer.line_value),
          callback: function($$v) {
            content.line_answer.line_value = $$v
          },
          expression: "content.line_answer.line_value"
        }
      }, _vm._l((_vm.lineOptions), function(i) {
        return _c('el-option', {
          key: i,
          attrs: {
            "value": i
          }
        })
      })), _vm._v(" "), _c('span', {
        staticClass: "line-tip"
      }, [_vm._v("到")]), _vm._v(" "), _c('el-select', {
        model: {
          value: (content.line_answer.line_end_value),
          callback: function($$v) {
            content.line_answer.line_end_value = $$v
          },
          expression: "content.line_answer.line_end_value"
        }
      }, _vm._l((_vm.lineEndOptions), function(i) {
        return _c('el-option', {
          key: i,
          attrs: {
            "value": i
          }
        })
      }))], 1), _vm._v(" "), _c('div', {
        staticClass: "q-radio"
      }, [_c('div', {
        staticClass: "icon-radio"
      }, [_vm._v("1.")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (content.line_answer.line_tag),
          expression: "content.line_answer.line_tag"
        }],
        staticClass: "radio-input",
        attrs: {
          "placeholder": "标签（选填）"
        },
        domProps: {
          "value": (content.line_answer.line_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            content.line_answer.line_tag = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "q-radio"
      }, [_c('div', {
        staticClass: "icon-radio"
      }, [_vm._v("2.")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (content.line_answer.line_end_tag),
          expression: "content.line_answer.line_end_tag"
        }],
        staticClass: "radio-input",
        attrs: {
          "placeholder": "标签（选填）"
        },
        domProps: {
          "value": (content.line_answer.line_end_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            content.line_answer.line_end_tag = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "square-li"
      }, [_c('h4', [_vm._v("列")]), _vm._v(" "), _vm._l((content.answer), function(item, i) {
        return _c('div', {
          staticClass: "q-radio"
        }, [_c('div', {
          staticClass: "icon-radio"
        }, [_vm._v(_vm._s(i + 1) + ".")]), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (item.description),
            expression: "item.description"
          }],
          staticClass: "radio-input",
          domProps: {
            "value": (item.description)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              item.description = $event.target.value
            }
          }
        }), _vm._v(" "), (_vm.focusIndex === index) ? _c('i', {
          staticClass: "el-icon-close",
          on: {
            "click": function($event) {
              _vm.deleteRadioFn(index, index1, i)
            }
          }
        }) : _vm._e()])
      }), _vm._v(" "), (_vm.focusIndex === index) ? _c('div', {
        staticClass: "q-radio"
      }, [_c('div', {
        staticClass: "icon-radio"
      }, [_vm._v(_vm._s(content.answer.length + 1) + ".")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.addRadio),
          expression: "addRadio"
        }],
        staticClass: "radio-add",
        domProps: {
          "value": (_vm.addRadio)
        },
        on: {
          "focus": function($event) {
            _vm.addRadioFn(index, index1)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.addRadio = $event.target.value
          }
        }
      })]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.focusIndex === index) ? _c('div', {
        staticClass: "q-item option-wrap"
      }, [_c('ul', {
        staticClass: "option-list"
      }, [_c('li', [_c('i', {
        staticClass: "iconfont icon-copy",
        on: {
          "click": function($event) {
            _vm.copyListFn(index)
          }
        }
      })]), _vm._v(" "), _c('li', [_c('i', {
        staticClass: "el-icon-delete",
        on: {
          "click": function($event) {
            _vm.deleteListFn(index)
          }
        }
      })]), _vm._v(" "), _c('li', [_c('span', [_vm._v("必填")]), _vm._v(" "), _c('el-switch', {
        attrs: {
          "width": 40,
          "on-color": "#4ca2ae",
          "on-text": "",
          "off-text": ""
        },
        model: {
          value: (data.is_required),
          callback: function($$v) {
            data.is_required = $$v
          },
          expression: "data.is_required"
        }
      })], 1)])]) : _vm._e()]) : _vm._e()
    })], 2)])
  }))]), _vm._v(" "), (_vm.data.question.length) ? _c('div', {
    staticClass: "form-sidebar"
  }, [_c('div', {
    staticClass: "sidebar-li",
    on: {
      "click": _vm.addListFn
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "form-save",
    on: {
      "click": _vm.saveFn
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "add-lang",
    attrs: {
      "title": "添加语言",
      "visible": _vm.addLangVisible,
      "close-on-click-modal": false,
      "top": "34%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addLangVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "li-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("选择语言")]), _vm._v(" "), _c('el-select', {
    staticClass: "q-select",
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.defaultLang),
      callback: function($$v) {
        _vm.defaultLang = $$v
      },
      expression: "defaultLang"
    }
  }, _vm._l((_vm.langList), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addLangVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addLangFn
    }
  }, [_vm._v("确 定")])], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6221b2e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/create.vue
// module id = zMSr
// module chunks = 1